import Vue from "vue";
import getLocale from "./getLocale";
import messages from "../language";
import VueI18n from "vue-i18n";
import bus from "./bus.js";
Vue.use(VueI18n);

export function initKeywords(){
    const i18n = new VueI18n({
        locale: getLocale(), // set locale
        messages // set locale messages
    });

    // Set listener on all keywords to open modal
    const keywords = document.getElementsByClassName("keyword");
    for(const keyword of keywords)
    {
        keyword.addEventListener("click", (event) => { 
            document.getElementById("keywordBody").innerHTML=i18n.t("text.kw_"+event.target.getAttribute("data-type"));
            bus.$emit("openModal");
        });
    }
}

export function addKeywords(str){
    let keywords = {
        "treatment": "treatment",
        "traitement": "treatment",
        "lung/respiratory condition": "lungcondition",
        "lung/ respiratory condition": "lungcondition",
        "affection pulmonaire ou respiratoir": "lungcondition",
        "heart surgery": "heartsurgery",
        "chirurgie cardiaque": "heartsurgery",
        "heart condition": "heartcondition",
        "affection cardiovasculaire": "heartcondition",
        "artery or vein disorder": "arterydisorder",
        "trouble des artères ou des veines": "arterydisorder",
        "pre-existing medical condition": "preexistingconditions",
        "état de santé préexistant":"preexistingconditions",
        "stability period":"stabilityperiod",
        "la période de stabilité": "stabilityperiod"
    }
    for(const keyword in keywords){
        const re = new RegExp(keyword, 'g');
        str = str.replace(re, '<a data-type="'+keywords[keyword]+'" href=javascript:void(0);" class="keyword">'+keyword+'</a>');
    }
    return str;
}